import { memo } from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import ConfirmDialog from "./confirm-dialog";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";

interface DeleteButtonProps extends ButtonProps {
  onClick: () => void;
  label?: string;
  dialogContent?: React.ReactNode;
  variant?: ButtonProps["variant"];
  className?: string;
  type?: ButtonProps["type"];
}

export const DeleteButton = memo(
  ({
    onClick,
    label,
    dialogContent,
    className,
    disabled,
    variant = "destructive",
    ...props
  }: DeleteButtonProps) => {
    const { t } = useTranslation();
    const { can_delete } = useModulePermissions();

    return (
      <ConfirmDialog
        title={t("deleteButton.confirmTitle")}
        yesLabel={t("deleteButton.confirmYesButton")}
        noLabel={t("deleteButton.confirmNoButton")}
        content={dialogContent || t("deleteButton.confirmContent")}
        onConfirm={onClick}
        variant="destructive"
      >
        <Button
          {...props}
          variant={variant}
          disabled={disabled || !can_delete}
          className={className}
        >
          <Trash2 className="w-4 h-4" />
          {label || t("deleteButton.label")}
        </Button>
      </ConfirmDialog>
    );
  },
);
